import InputBox from './inputBox.vue'

const commonComponent = {
  install: function (Vue) {
    Vue.component('InputBox', InputBox)
  }
}

export default commonComponent



// WEBPACK FOOTER //
// ./src/components/common/index.js